import React, { useState } from "react";
import "./SupportButton.scss";
import { ReactSVG } from "react-svg";
import supportButton from "../../Assets/icons/thumbs.svg";
import SupportModal from "./SupportModal";
import { useTranslation } from "react-i18next";

const SupportButton = (props) => {

    const { subject, feature } = props;

    const [showModal, setShowModal] = useState(false);

    function openSupportModal() {
        setShowModal(true);
    }

    const { t } = useTranslation();

    return (
        <>
            <SupportModal subject={subject} feature={feature} showModal={showModal} setShowModal={setShowModal} />
            <div className="supportButton" onClick={openSupportModal} data-click-target="modal" data-click-source="feedback">
                { !process.env.REACT_APP_IS_RESELLER && <ReactSVG src={supportButton} /> }
                <span>{t(process.env.REACT_APP_IS_RESELLER ? 'reseller.support.button' : 'support.button')}</span>
            </div>
        </>
    );
};

export default SupportButton;